module.exports = __webpack_public_path__ + "img/bullhorn.57af6141.svg";